<template>
  <div>
    <div class="row no-gutters commodity_area">
      <div class="title col">{{ num }}.{{ name }}</div>
      <div class="row no-gutters amount_area">
        <span class="col amount_text">{{ amount }}</span>
        <div class="col-auto price">NT${{ subtotalText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPrice, isEmpty} from "../util/helpers";

export default {
  name: "OrderCommodity",
  computed: {
    num() {
      return this.index + 1;
    },
    name() {
      return this.item.Commodity.name;
    },
    subtotal() {
      let val = this.item.price;
      return isEmpty(val) ? 0 : val;
    },
    subtotalText() {
      return getPrice(this.subtotal);
    },
    amount() {
      return this.item.amount;
    },
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {},
}
</script>

<style scoped>
.commodity_area {
  padding: 10px 0 10px 0;
}

.title {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

.info {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 350;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

.price {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}


.amount_area {
  width: 260px;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .amount_area {
    width: 26vw;
  }
}

.amount_text {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #333333;
}


</style>
